import { createSlice } from '@reduxjs/toolkit';

export interface MapState {
  token: string;
}

const initialState: MapState = { token: '' };

export const MapSlice = createSlice({
  name: 'Map',
  initialState,
  reducers: {
  },
});

// export const { saveToken, logout } = AuthSlice.actions;

export default MapSlice.reducer;
